(function () {
  'use strict';

  /* =========================================================
     JEDANSÉ — LA ROBE APRÈS
     FINAL BUNDLY QUICK VIEW

     Bundly owns:
     - popup
     - S / M
     - Add to Bundle

     JEDANSÉ owns:
     - custom image gallery
     - information tabs
     - visual presentation
  ========================================================= */


  const qa = (selector, root = document) =>
    Array.from(root.querySelectorAll(selector));


  const clean = value =>
    (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();


  function visible(el) {
    if (!el) return false;

    const style =
      window.getComputedStyle(el);

    const rect =
      el.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }


  /* =========================================================
     ADD BUTTON
  ========================================================= */

  function findAddButton(root) {
    if (!root) return null;

    return (
      qa(
        'button, input[type="button"], input[type="submit"], [role="button"]',
        root
      ).find(el => {
        if (!visible(el)) return false;

        const value =
          clean(
            el.textContent ||
            el.value
          );

        return (
          value.includes('add to bundle') ||
          value.includes('add to your set')
        );
      }) || null
    );
  }


  /* =========================================================
     FIND THE ROBE DIALOG FROM OUR METAFIELD

     Important:
     .jd-robe-dialog-data may initially be hidden.
     We therefore DO NOT require the metafield itself
     to be visible.
  ========================================================= */

  function findRobeDialog() {
    const allData =
      qa('.jd-robe-dialog-data');


    for (const data of allData) {

      const semantic =
        data.closest(
          'dialog, [role="dialog"]'
        );


      if (
        semantic &&
        visible(semantic) &&
        findAddButton(semantic)
      ) {
        return {
          data,
          dialog: semantic
        };
      }


      let node =
        data.parentElement;


      while (
        node &&
        node !== document.body
      ) {

        const add =
          findAddButton(node);


        const images =
          qa('img', node)
            .filter(img => {
              return (
                visible(img) &&
                !img.closest(
                  '.jd-robe-dialog-data'
                ) &&
                !img.closest(
                  '.jd-final-gallery'
                )
              );
            });


        if (
          add &&
          images.length >= 2
        ) {
          return {
            data,
            dialog: node
          };
        }


        node =
          node.parentElement;
      }
    }


    return null;
  }


  /* =========================================================
     INFORMATION POSITION
  ========================================================= */

  function positionInformation(
    data,
    add
  ) {
    if (
      !data ||
      !add ||
      !add.parentElement
    ) {
      return;
    }


    if (
      data.parentElement !==
        add.parentElement ||
      data.nextElementSibling !==
        add
    ) {

      add.parentElement.insertBefore(
        data,
        add
      );
    }
  }


  /* =========================================================
     TABS

     We use the native hidden property as well as CSS.

     Therefore only ONE panel can remain visible,
     even if some theme CSS tries to interfere.
  ========================================================= */

  function setTab(
    data,
    target
  ) {

    qa(
      '[data-jd-robe-tab]',
      data
    ).forEach(button => {

      const active =
        button.dataset.jdRobeTab ===
        target;


      button.classList.toggle(
        'is-active',
        active
      );


      button.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );
    });


    qa(
      '[data-jd-robe-panel]',
      data
    ).forEach(panel => {

      const active =
        panel.dataset.jdRobePanel ===
        target;


      panel.hidden =
        !active;


      panel.classList.toggle(
        'is-active',
        active
      );
    });
  }


  function bindTabs(data) {

    qa(
      '[data-jd-robe-tab]',
      data
    ).forEach(button => {

      if (
        button.dataset.jdFinalTabBound ===
        '1'
      ) {
        return;
      }


      button.dataset.jdFinalTabBound =
        '1';


      button.addEventListener(
        'click',
        event => {

          event.preventDefault();

          event.stopPropagation();


          setTab(
            data,
            button.dataset.jdRobeTab
          );
        }
      );
    });


    setTab(
      data,
      'size'
    );
  }


  /* =========================================================
     PRODUCT INFORMATION ACCORDIONS
  ========================================================= */

  function prepareDetails(data) {

    if (
      data.dataset.jdFinalDetails ===
      '1'
    ) {
      return;
    }


    data.dataset.jdFinalDetails =
      '1';


    const details =
      qa(
        '.jd-robe-product',
        data
      );


    details.forEach(
      (item, index) => {

        /*
          Product Description open.
          Fabric + Care closed initially.
        */

        item.open =
          index === 0;
      }
    );
  }


  /* =========================================================
     IMAGE URL
  ========================================================= */

  function bestURL(img) {
    if (!img) return '';


    const srcset =
      img.getAttribute('srcset');


    if (srcset) {

      const candidates =
        srcset
          .split(',')
          .map(item => {

            const parts =
              item
                .trim()
                .split(/\s+/);


            return {
              url:
                parts[0] || '',

              width:
                parseInt(
                  parts[1] || '0',
                  10
                ) || 0
            };

          })
          .filter(
            item =>
              item.url
          )
          .sort(
            (a, b) =>
              b.width -
              a.width
          );


      if (
        candidates.length
      ) {
        return candidates[0].url;
      }
    }


    return (
      img.getAttribute(
        'data-src'
      ) ||
      img.currentSrc ||
      img.getAttribute(
        'src'
      ) ||
      img.src ||
      ''
    );
  }


  function imageKey(url) {
    if (!url) return '';


    try {

      const parsed =
        new URL(
          url,
          window.location.href
        );


      /*
        Width / crop query parameters should not
        make one Shopify image look like several.
      */

      return parsed.pathname;

    } catch (error) {

      return url.split('?')[0];

    }
  }


  /* =========================================================
     NATIVE IMAGE COLLECTION

     We only READ Bundly's images.

     We never modify them.
  ========================================================= */

  function getNativeImages(dialog) {

    const images =
      qa('img', dialog)
        .filter(img => {

          return (
            visible(img) &&
            !img.closest(
              '.jd-robe-dialog-data'
            ) &&
            !img.closest(
              '.jd-final-gallery'
            )
          );

        });


    if (!images.length) {
      return [];
    }


    /*
      Largest visible image = Bundly's native hero.
    */

    const sorted =
      images
        .slice()
        .sort((a, b) => {

          const ar =
            a.getBoundingClientRect();

          const br =
            b.getBoundingClientRect();


          return (
            br.width *
            br.height
          ) -
          (
            ar.width *
            ar.height
          );

        });


    const main =
      sorted[0];


    const result =
      [];


    const seen =
      new Set();


    /*
      Put native hero first.
    */

    [
      main,
      ...images
    ].forEach(img => {

      const url =
        bestURL(img);


      const key =
        imageKey(url);


      if (
        !url ||
        !key ||
        seen.has(key)
      ) {
        return;
      }


      seen.add(key);


      result.push({
        url,
        alt:
          img.alt ||
          'LA ROBE APRÈS'
      });
    });


    return result;
  }


  /* =========================================================
     FIND LEFT MEDIA COLUMN

     We climb from the largest native image.

     We STOP before entering any parent containing
     our product information or Add button.

     Therefore we never restructure Bundly's dialog.
  ========================================================= */

  function findMediaRoot(
    dialog,
    data,
    add
  ) {

    const images =
      qa('img', dialog)
        .filter(img => {

          return (
            visible(img) &&
            !img.closest(
              '.jd-robe-dialog-data'
            ) &&
            !img.closest(
              '.jd-final-gallery'
            )
          );

        });


    if (!images.length) {
      return null;
    }


    const main =
      images
        .slice()
        .sort((a, b) => {

          const ar =
            a.getBoundingClientRect();

          const br =
            b.getBoundingClientRect();


          return (
            br.width *
            br.height
          ) -
          (
            ar.width *
            ar.height
          );

        })[0];


    let root =
      main.parentElement;


    if (!root) {
      return null;
    }


    while (
      root.parentElement &&
      root.parentElement !==
        dialog
    ) {

      const parent =
        root.parentElement;


      /*
        The moment the next parent also contains
        product information / Add to Bundle,
        we have reached Bundly's overall content row.

        Do not climb any further.
      */

      if (
        parent.contains(data) ||
        parent.contains(add)
      ) {
        break;
      }


      root =
        parent;
    }


    return root;
  }


  /* =========================================================
     BUILD OUR OWN GALLERY

     This completely eliminates the repeated failure
     with Bundly's non-responsive thumbnails.
  ========================================================= */

  function buildGallery(
    dialog,
    data,
    add
  ) {

    const root =
      findMediaRoot(
        dialog,
        data,
        add
      );


    if (!root) {
      return;
    }


    const images =
      getNativeImages(
        dialog
      );


    if (
      images.length < 2
    ) {
      return;
    }


    root.classList.add(
      'jd-final-media-root'
    );


    let gallery =
      root.querySelector(
        ':scope > .jd-final-gallery'
      );


    if (!gallery) {

      gallery =
        document.createElement(
          'div'
        );


      gallery.className =
        'jd-final-gallery';


      root.appendChild(
        gallery
      );
    }


    /*
      Rebuild because Bundly may rerender the
      product after an S/M change.
    */

    gallery.innerHTML =
      '';


    /* ---------------- MAIN IMAGE ---------------- */

    const mainWrap =
      document.createElement(
        'div'
      );


    mainWrap.className =
      'jd-final-gallery__main-wrap';


    const mainImage =
      document.createElement(
        'img'
      );


    mainImage.className =
      'jd-final-gallery__main';


    mainImage.src =
      images[0].url;


    mainImage.alt =
      images[0].alt;


    mainWrap.appendChild(
      mainImage
    );


    gallery.appendChild(
      mainWrap
    );


    /* ---------------- THUMBNAILS ---------------- */

    const thumbs =
      document.createElement(
        'div'
      );


    thumbs.className =
      'jd-final-gallery__thumbs';


    images.forEach(
      (image, index) => {

        const button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.className =
          'jd-final-gallery__thumb';


        if (
          index === 0
        ) {

          button.classList.add(
            'is-active'
          );
        }


        button.setAttribute(
          'aria-label',
          'View product image ' +
          (index + 1)
        );


        const thumb =
          document.createElement(
            'img'
          );


        thumb.src =
          image.url;


        thumb.alt =
          image.alt;


        button.appendChild(
          thumb
        );


        /*
          These are OUR buttons.

          Bundly has no click handler attached to them.
        */

        button.addEventListener(
          'click',
          event => {

            event.preventDefault();

            event.stopPropagation();


            mainImage.src =
              image.url;


            mainImage.alt =
              image.alt;


            qa(
              '.jd-final-gallery__thumb',
              thumbs
            )
            .forEach(other => {

              other.classList.remove(
                'is-active'
              );
            });


            button.classList.add(
              'is-active'
            );
          }
        );


        thumbs.appendChild(
          button
        );
      }
    );


    gallery.appendChild(
      thumbs
    );
  }


  /* =========================================================
     SIZE
  ========================================================= */

  function decorateSize(dialog) {

    qa(
      'button, label, [role="button"]',
      dialog
    ).forEach(el => {

      const value =
        clean(
          el.textContent
        );


      if (
        value === 's' ||
        value === 'm'
      ) {

        el.classList.add(
          'jd-final-native-size'
        );
      }
    });
  }


  /* =========================================================
     ENHANCE DIALOG
  ========================================================= */

  function enhance() {

    const found =
      findRobeDialog();


    if (!found) {
      return;
    }


    const {
      data,
      dialog
    } = found;


    const add =
      findAddButton(
        dialog
      );


    if (!add) {
      return;
    }


    dialog.classList.add(
      'jd-robe-qv-final'
    );


    data.classList.add(
      'is-enhanced'
    );


    positionInformation(
      data,
      add
    );


    bindTabs(
      data
    );


    prepareDetails(
      data
    );


    decorateSize(
      dialog
    );


    /* ---------------- ADD BUTTON ---------------- */

    add.classList.add(
      'jd-final-native-add'
    );


    const addText =
      clean(
        add.textContent ||
        add.value
      );


    if (
      addText.includes(
        'add to bundle'
      )
    ) {

      if (
        add.tagName ===
        'INPUT'
      ) {

        add.value =
          'ADD TO YOUR SET';

      } else {

        add.textContent =
          'ADD TO YOUR SET';
      }
    }


    /*
      Allow Bundly to finish laying out its images,
      then create our gallery OVER the native media.
    */

    requestAnimationFrame(
      () => {

        requestAnimationFrame(
          () => {

            buildGallery(
              dialog,
              data,
              add
            );

          }
        );

      }
    );
  }


  /* =========================================================
     SCHEDULER
  ========================================================= */

  let queued =
    false;


  function schedule() {

    if (queued) {
      return;
    }


    queued =
      true;


    requestAnimationFrame(
      () => {

        queued =
          false;


        enhance();

      }
    );
  }


  /* =========================================================
     OFFICIAL BUNDLY EVENTS
  ========================================================= */

  [
    'bundly:afterToggleProductDialog',
    'bundly:afterChangeVariantOption',
    'bundly:afterUpdateBlock',
    'bundly:afterLoadBundle'
  ]
  .forEach(name => {

    document.addEventListener(
      name,
      schedule
    );

  });


  /* =========================================================
     FALLBACK
  ========================================================= */

  const observer =
    new MutationObserver(
      mutations => {

        const relevant =
          mutations.some(
            mutation => {

              return Array.from(
                mutation.addedNodes
              )
              .some(node => {

                if (
                  !(
                    node instanceof
                    Element
                  )
                ) {
                  return false;
                }


                return (
                  node.matches(
                    '.jd-robe-dialog-data'
                  ) ||
                  node.querySelector(
                    '.jd-robe-dialog-data'
                  )
                );

              });

            }
          );


        if (relevant) {
          schedule();
        }

      }
    );


  /* =========================================================
     START
  ========================================================= */

  function start() {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );


    schedule();


    setTimeout(
      schedule,
      150
    );


    setTimeout(
      schedule,
      400
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );

  } else {

    start();
  }

})();